export default __webpack_public_path__ + "static/media/hbs-cbb-poster-2.1102ffe1.jpg";